import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="clips-back"
export default class extends Controller {
  static returnUrlStorageKey = 'clipsBackReturnUrl'

  static values = {
    fallbackUrl: String
  }

  rememberReturnContext(event) {
    const returnContext = {
      fromUrl: window.location.href,
      toUrl: event.currentTarget.href
    }

    window.sessionStorage.setItem(this.constructor.returnUrlStorageKey, JSON.stringify(returnContext))
  }

  navigate(event) {
    if (this.shouldGoBack()) {
      event.preventDefault()
      window.history.back()
    }
  }

  shouldGoBack() {
    if (window.history.length <= 1) return false

    const fallbackUrl = this.parseUrl(this.fallbackUrlValue)
    if (!fallbackUrl) return false

    const storedContext = this.storedReturnContext()
    if (!storedContext) return false

    const storedFromUrl = this.parseUrl(storedContext.fromUrl)
    const storedToUrl = this.parseUrl(storedContext.toUrl)
    if (!storedFromUrl || !storedToUrl) return false
    if (storedFromUrl.origin !== fallbackUrl.origin) return false
    if (storedToUrl.href !== window.location.href) return false

    return this.matchesIndexPath(storedFromUrl.pathname, fallbackUrl.pathname)
  }

  parseUrl(value) {
    try {
      return new URL(value, window.location.origin)
    } catch {
      return null
    }
  }

  storedReturnContext() {
    const storedValue = window.sessionStorage.getItem(this.constructor.returnUrlStorageKey)
    if (!storedValue) return null

    try {
      return JSON.parse(storedValue)
    } catch {
      return null
    }
  }

  matchesIndexPath(pathname, indexPath) {
    return this.normalizedPath(pathname) === this.normalizedPath(indexPath)
  }

  normalizedPath(pathname) {
    if (pathname === '/') return '/'

    return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
  }
}
